import { Button, Icon } from "@components/library";
import SlideModalBase, { SlideModalBaseProps } from "@components/library/ModalBases/SlideModalBase";
import { COLORS } from "@constants";
import { RootState } from "@redux/store";
import { contact_path, login_path } from "@routes/routes";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import useNavbarLinks from "./useNavbarLinks";

const LoggedOutMobileMenu = ({ isOpen, onClose }: SlideModalBaseProps) => {
  if (!isOpen) return null;

  const currentUser = useSelector((state: RootState) => state.profiles.currentUser);

  const { pathname } = useLocation();

  const navbarLinks = useNavbarLinks();

  return (
    <SlideModalBase isOpen={isOpen} onClose={onClose} direction="bottom" hideCloseButton>
      <Container>
        <NavLinks>
          <CloseButton type="button" onClick={onClose}>
            <Icon name="Close" size="lg" />
          </CloseButton>
          {navbarLinks.map((link) => (
            <NavLink
              key={link.to}
              href={link.to}
              isCurrentPage={pathname.startsWith(link.to)}
              onClick={onClose}
            >
              {link.label}
            </NavLink>
          ))}
        </NavLinks>
        {!currentUser.id && (
          <>
            <Button
              to={contact_path()}
              isExternalLink
              variant="ghost"
              margin="24px 0 0"
              width="100%"
            >
              Contact sales
            </Button>
            <Button
              to={login_path()}
              isExternalLink
              variant="secondary"
              margin="8px 0 0"
              width="100%"
            >
              Sign in
            </Button>
          </>
        )}
      </Container>
    </SlideModalBase>
  );
};

export default LoggedOutMobileMenu;

const Container = styled.div`
  position: relative;
  padding: 40px;
`;
const CloseButton = styled.button`
  position: absolute;
  top: 40px;
  right: 32px;
  border: none;
  background-color: transparent;
`;
const NavLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const NavLink = styled.a`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.7;
  color: ${({ isCurrentPage }) => (isCurrentPage ? COLORS.HALO_BLUE : COLORS.BLACK)};
  &:hover {
    color: ${COLORS.HALO_BLUE};
    text-decoration: none;
  }
`;
